import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { IconContext } from 'react-icons/lib';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import CloseBtn from '../../images/close-btn.svg';
import HamburgerBtn from '../../images/hamburger-btn.svg';
import './Sidebar.scss';
import SidebarContent from './SidebarContent';

const Nav = styled.div`
    background-image: ${({ location }) =>
        location === '/'
            ? 'linear-gradient(to right, rgb(238, 238, 238), rgb(252, 252, 252))'
            : 'linear-gradient(to right, rgb(239, 239, 239), rgb(250, 248, 248))'};
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

// const Nav = styled.div`
//     background-image: linear-gradient(to right, rgb(238, 238, 238), rgb(252, 252, 252));
//     height: 80px;
//     display: flex;
//     justify-content: flex-start;
//     align-items: center;
// `;

const NavIcon = styled(Link)`
    margin-left: 2rem;
    font-size: 2rem;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: default;
`;

const SidebarNav = styled.nav`
    background: #fff;
    width: 17rem;
    height: 100vh;
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    left: ${({ sidebar }) => (sidebar ? '0' : '-100%')};
    transition: ${({ sidebar }) => (sidebar ? '350ms' : '850ms')};
    z-index: 10;
`;

// const SidebarNav = styled.nav`
//     width: 250px;
//     height: 100vh;
//     display: flex;
//     justify-content: center;
//     position: fixed;
//     top: ${({ scroll }) => (scroll ? '0' : 'initial')};
//     left: ${({ sidebar }) => (sidebar ? '0' : '-100%')};
//     transition: ${({ sidebar }) => (sidebar ? '350ms' : '850ms')};
//     z-index: 10;
// `;

const SidebarWrap = styled.div`
    width: 100%;
`;

const Sidebar = (props) => {
    const { username } = props;
    const [scroll, setScroll] = useState(0);

    const [sidebar, setSidebar] = useState(false);
    const showSidebar = () => setSidebar(!sidebar);

    const [closeIcon, setCloseIcon] = useState(false);
    const showCloseIcon = useCallback(() => { setCloseIcon(!closeIcon) }, [closeIcon]);

    const handleIsActive = () => props.setIsActive(!props.isActive)

    const ref = useRef();
    
    const location = useLocation();

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            // If the menu is open and the clicked target is not within the menu,
            // then close the menu
            if (sidebar && ref.current && !ref.current.contains(e.target)) {
                setSidebar(false);
            }
        };
        document.addEventListener('mousedown', checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [sidebar, ref]);

    useEffect(() => {
        const onScroll = () => {
            document.addEventListener("scroll", () => {
                const scrollCheck = window.scrollY > 5
                if (scrollCheck !== scroll) {
                    setScroll(scrollCheck)
                    showCloseIcon(!closeIcon)
                }
            })
        };
        // setting the event handler from web API
        document.addEventListener("scroll", onScroll)
        // cleaning up from the web API
        return () => {
            document.removeEventListener("scroll", onScroll)
        };
    }, [scroll, setScroll, closeIcon, showCloseIcon])

    return (
        <Fragment>
            <IconContext.Provider value={''} ref={ref}>
                <Nav location={location.pathname}>
                    <div className='sidebar-icon-container'>
                        <img src={HamburgerBtn} onClick={() => {showSidebar(); handleIsActive()}} className='sidebar-icon' alt='' />
                    </div>
                    {/* <PageTitle>
                        <h4>Welcome, {username}</h4>
                    </PageTitle> */}
                </Nav>
                <SidebarNav sidebar={sidebar} scroll={scroll}>
                    <SidebarWrap>
                    <div className='sidebar-icon-container'> 
                        <img src={CloseBtn} onClick={() => {showSidebar(); handleIsActive()}} className='sidebar-icon' alt='' />
                    </div>                    
                        {/* {
                            closeIcon && 
                            <NavIcon to='#'>
                                <AiIcons.AiOutlineClose onClick={showSidebar} />
                            </NavIcon>
                        } */}
                        <SidebarContent loginList={props.loginList} grievancePermission={props.grievancePermission} />
                    </SidebarWrap>
                </SidebarNav>
            </IconContext.Provider>
        </Fragment>
    );
};

export default Sidebar;
